import React, {Component} from 'react';
import "./ResponsiveFooter.css";
import {FormattedMessage} from "react-intl";
import {HashLink as Link} from "react-router-hash-link";
import {BASE_URL, PAGE_OPEN_TYPE} from "../../../../configuration";

class ResponsiveFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quotationPcb: {
                orderType: 1,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },
            quotationStencil: {
                orderType: 3,
                fileKey: "",
                pcbParam: {
                    materialDetails: 0,
                    panelFlag: 0,
                    edgeRails: 0,
                    layer: 2,
                    length: 100,
                    width: 100,
                    qty: 5,
                    thickness: 1.6,
                    impedance: 1,
                    pcbColor: 0,
                    surfaceFinish: 0,
                    copperWeight: 1,
                    goldFinger: 0,
                    panelByJLCPCB_X: 0,
                    panelByJLCPCB_Y: 0,
                    differentDesign: 1,
                    flyingProbe: 1,
                    castellatedHoles: 0,
                    silkColor: 1,
                    orderDetailsRemark: ""

                },
                smtStencilParam: {
                    dimensionsID: 112,
                    stencilQty: 1,
                    electropolishing: 0,
                    fiducials: 0,
                    customizeFlag: 0,
                    customizeSizeX: 0,
                    customizeSizeY: 0,
                    customizeSize: 0,
                    stencilSide: 0,
                    orderRemark: "",
                    framework: 0
                }
            },

        };

    }
    componentDidMount() {

        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }

    render() {
        return (
            <div id="footer-margin-cart">
                <button className="responsive-footer-copyrignt">
                    ©KitCutLabo. All Rights Reserved.
                </button>
            </div>
        );
    }
}

export default ResponsiveFooter;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/Footer/ResponsiveFooter.js